import React, { useEffect, useState } from 'react';
import { RootState } from 'src/store/reducers/state';
import { useCategoryActions } from 'src/store/category/actions';
import { useDispatch, useSelector } from 'react-redux';
import AddNewContentType from '../AddNewContentTypes';
import DeleteContentTypeModal from '../DeleteContentType';
import Pagination from 'src/components/common/pagination';
import { CategoryData } from 'src/models/categoryModel';
import AddNewTag from '../AddNewTag';
import Loader from 'src/components/loader';
import { DebounceInput } from 'react-debounce-input';
interface IProps {
  setSelectedContentTypeId: (value: CategoryData) => void;
  setTabFlag: (value: number) => void;
}
const ContentTypes: React.FC<IProps> = ({ setSelectedContentTypeId, setTabFlag }) => {
  const dispatch = useDispatch();
  const categoryActions = useCategoryActions(dispatch);
  const [contentTypeAddFlag, setContentTypeAddFlag] = useState<string>('Add');
  const [searchValue, setSearchValue] = useState<string>('');
  const [contentTypeId, setContentTypeId] = useState<string>('');
  const {
    contentType,
    isContentTypeSaved,
    isContentTypeUpdated,
    isContentTypeDeleted,
    contentTypePaginationMeta
  } = useSelector((state: RootState) => {
    return {
      contentType: state.category.contentType,
      isContentTypeSaved: state.category.isContentTypeSaved,
      isContentTypeUpdated: state.category.isContentTypeUpdated,
      isContentTypeDeleted: state.category.isContentTypeDeleted,
      contentTypePaginationMeta: state.category.contentTypePaginationMeta
    };
  });

  useEffect(() => {
    if (isContentTypeSaved || isContentTypeUpdated || isContentTypeDeleted) {
      categoryActions.getContentTypeRequest({ pageNumber: 1 });
    }
  }, [isContentTypeSaved, isContentTypeUpdated, isContentTypeDeleted]);

  const handleEditClick = (contentTypeId: string) => {
    categoryActions.getSingleContentTypeRequest(contentTypeId);
    setContentTypeAddFlag('Edit');
  };
  const handlePageChange = (pageNumber: number) => {
    const data = { querySearch: searchValue, pageNumber };
    categoryActions.getContentTypeRequest(data);
  };
  const handleDeleteClick = (data: CategoryData) => {
    setContentTypeId(data.id);
    setSelectedContentTypeId({ id: data.id, name: data.name });
    setTabFlag(2);
  };
  const handleSearchContentType = (e: string) => {
    setSearchValue(e);
    categoryActions.getContentTypeRequest({ querySearch: e, pageNumber: 1 });
  };
  return (
    <>
      <div className="tab-pane fade " id="tabs-contentTypes" role="tabpanel">
        <div className="py-5 px-7">
          <div className="px-5 py-4 border-b border-gray-100 md:flex justify-between items-center">
            <h2 className="font-semibold "></h2>
            <div className="md:flex items-center text-center">
              <div className="form-group md:flex items-center text-center">
                <label className="mr-1 font-semibold">Search:</label>
                <DebounceInput
                  placeholder="Search"
                  minLength={1}
                  className="input-style w-48 mr-3 mb-1"
                  debounceTimeout={500}
                  onChange={(event) => handleSearchContentType(event.target.value)}
                />
              </div>
              <button
                onClick={() => setContentTypeAddFlag('Add')}
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#AddNewContentType"
                className="btn-primary w-auto mt-0 mr-0 ml-auto borderonly-btn">
                Add
              </button>
            </div>
          </div>
          <div className="overflow-x-auto-sm">
            <table className="table-auto w-full border">
              <thead className="text-xs font-semibold uppercase bg-gray-100">
                <tr>
                  <th className="p-2">
                    <div className="font-semibold text-left">Content Type</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Content Type Description</div>
                  </th>
                  <th className="p-2">
                    <div className="text-left invisible">Action</div>
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm divide-y divide-gray-100">
                {contentType &&
                  contentType.map((contentType) => {
                    return (
                      <tr key={contentType.id}>
                        <td className="p-2">{contentType.contentType}</td>
                        <td className="p-2">{contentType.description}</td>
                        <td className="p-2">
                          <div className="dropdown relative">
                            <a
                              className="
                              dropdown-toggle
                              transition
                              duration-150
                              ease-in-out border h-8 w-8 flex items-center justify-center rounded-md"
                              href="#"
                              type="button"
                              id="ActionButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false">
                              <i className="fas fa-ellipsis-v"></i>
                            </a>
                            <ul
                              className="dropdown-menu action-dropdown"
                              aria-labelledby="ActionButton">
                              <li
                                data-bs-toggle="modal"
                                data-bs-target="#AddNewContentType"
                                onClick={() => handleEditClick(contentType.id)}>
                                <span className="dropdown-item flex-items cursor-pointer">
                                  <i className="fas fa-edit w-6"></i>
                                  <span>Edit</span>
                                </span>
                              </li>
                              <li
                                onClick={() =>
                                  handleDeleteClick({
                                    id: contentType.id,
                                    name: contentType.contentType
                                  })
                                }>
                                <span
                                  className="dropdown-item flex-items cursor-pointer text-red-500"
                                  data-bs-toggle="modal"
                                  data-bs-target="#DeleteContentTypeModal">
                                  <i className="fas fa-trash w-6"></i>
                                  <span>Delete</span>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {!!contentTypePaginationMeta && !!Object.keys(contentTypePaginationMeta).length && (
              <Pagination
                currentPage={contentTypePaginationMeta.pageNumber}
                totalCount={contentTypePaginationMeta.totalCount}
                pageSize={contentTypePaginationMeta.pageSize}
                onPageChange={(page: any) => handlePageChange(page)}
              />
            )}
          </div>
        </div>
      </div>
      <AddNewContentType contentTypeAddFlag={contentTypeAddFlag} />
      <DeleteContentTypeModal contentTypeId={contentTypeId} />
    </>
  );
};

export default ContentTypes;
